import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaTextBoldProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaTextBold extends Component<KuikaTextBoldProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-text--bold", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaTextBold;
